<template>

    <BonusesPrint :info="info" :signatureInfo="signatureInfo" :correlatorDate="correlatorDate" :fullName="fullName"/>

</template>

<script>
export default {
 components: {},
 created() {
   let id = this.$route.params.id;
   this.$store.dispatch("bonuses/getCurrentBonus", id).then((res) => {
     this.info = res.employee;
     this.signatureInfo = res.signatureInfo;
   });
 },
 computed: {
       fullName() {
           return this.$store.state.security.user.fullName;
       },
       correlatorDate() {
           if (this.info.bonusDate != null) {
               const newDate = this.subtractYears(new Date(this.info.bonusDate), 1);

               return newDate;
           }
           else return new Date();
       }

   },
 
 data() {
   return {
     info: {
       fullName: null,
       dministrationName: null,
       CorrelatorId: null,
       CorrelatorDate: null,
       jobGradeName: null,
       bonusDate: null,
     },
     signatureInfo: {
       name: null,
       job: null,
       approvedName: null,
       approvedJob: null,
     }

   };
 },
 methods:{
   subtractYears(date, years) {
           date.setFullYear(date.getFullYear() - years);
           return date;
       },
      
 }
};
</script>
